/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listGrowthPathsByUserId = /* GraphQL */ `
  query FindGrowthPathsByUserIdCustom(
    $userId: ID!
    $dateTimeAdded: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserGrowthPathItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathsByUserId(
      userId: $userId
      dateTimeAdded: $dateTimeAdded
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        growthPathItemId
        growthPathItem {
          id
          type
          title
          subtitle
          avatarUrl
          description
          categoryName
          categoryId
          estimatedCompletionTimeInMins
          actionTitle
          actionDestination
          actionPayload
          createdAt
          updatedAt
        }
        userId
        dateTimeAdded
        completed
        locked
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listUsers = /* GraphQL */ `
  query ListUsersCustom($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        referralSource
        roles
        plans(filter: { active: { eq: TRUE } }, sortDirection: DESC) {
          items {
            id
            userId
            planId
            plan {
              id
              planGroupId
              name
              description
              active
              defaultPrice
              defaultPlanPriceId
              discountsAllowed
              display
              isTrial
              upgradeable
              downgradeable
              features
              createdAt
              level
              pricing {
                nextToken
              }
              metadata {
                coachingSessionsAllocated
                stripeProductId
              }
              updatedAt
            }
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            metadata {
              stripeSubscriptionId
              stripeCustomerId
            }
            updatedAt
          }
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          stipeCustomerId
        }
        updatedAt
      }
      nextToken
    }
  }
`;

export const getEvent = /* GraphQL */ `
  query GetEventCustom($id: ID!) {
    getEvent(id: $id) {
      id
      name
      title
      description
      features {
        title
        description
      }
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      hostFirstName
      hostLastName
      hostEmail
      hostWebsite
      hostAvatar
      allowFreeMembers
      allowSprout
      allowBloom
      eventType
      attendeeLimit
      attendees {
        items {
          eventSessionId
          userId
          eventId
          confirmed
          confirmationTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          eventId
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          eventSessionAttendees {
            items {
              eventSessionId
              userId
              eventId
              confirmed
            }
          }
          eventSessionFocusAreaId
          createdAt
          updatedAt
        }
        nextToken
      }
      price
      metadata {
        stripeProductId
        stripePriceId
        eventLandingPageUrl
        eventMeetingLink
      }
      createdAt
      updatedAt
    }
  }
`;

export const listEventsByEventType = /* GraphQL */ `
  query ListEventsByEventTypeCustom(
    $eventType: EventTypeEnum!
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventsByEventType(eventType: $eventType, startDate: $startDate, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            metadata {
              chatChannelId
              eventSessionLandingPageUrl
              eventSessionMeetingLink
              actuityAppointmentTypeId
              acuityCalendarId
              activeCampaignTagId
            }
            eventSessionAttendees {
              items {
                eventSessionId
                userId
                eventId
                confirmed
              }
            }
            eventSessionFocusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
